// Central Color Palette for Vehicle Routes
// Ensures consistent colors across the entire application

export const VEHICLE_ROUTE_COLORS = [
  '#ef4444', // red
  '#3b82f6', // blue
  '#22c55e', // green
  '#f59e0b', // amber
  '#8b5cf6', // violet
  '#ec4899', // pink
  '#14b8a6', // teal
  '#f97316', // orange
  '#06b6d4', // cyan
  '#10b981', // emerald
  '#a855f7', // purple
  '#f43f5e', // rose
  '#84cc16', // lime
  '#6366f1', // indigo
  '#fbbf24', // yellow
  '#fb923c', // orange-400
  '#4ade80', // green-400
  '#60a5fa', // blue-400
  '#c026d3', // fuchsia-600
  '#0ea5e9', // sky-500
];

export const getVehicleColorByIndex = (index: number): string => {
  return VEHICLE_ROUTE_COLORS[index % VEHICLE_ROUTE_COLORS.length];
};

export const getVehicleColorById = (vehicleId: string | number): string => {
  // Extract number from vehicle_001, vehicle_002, etc.
  const id = typeof vehicleId === 'string'
    ? parseInt(vehicleId.replace(/\D/g, ''))
    : vehicleId;

  // Use the ID directly to get consistent color
  return VEHICLE_ROUTE_COLORS[(id - 1) % VEHICLE_ROUTE_COLORS.length];
};
